/*默认图片*/
let defaultImg = require('@/assets/img/default.png')
let defaultHeader = require('@/assets/img/img_male_default.png')
export {
  defaultImg,
  defaultHeader
}



// WEBPACK FOOTER //
// ./src/config/env.js